import { type DefaultOptions, QueryClient } from "@tanstack/react-query";

const queryConfig: DefaultOptions = {
    queries: {
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 30000,
    },
    mutations: {
        throwOnError: true,
    },
};

export const queryClient = new QueryClient({ defaultOptions: queryConfig });
